import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule, RequestOptions, XHRBackend, Http } from '@angular/http';
import { RouterModule, Router } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';

// libs
import { DialogModule } from 'primeng/dialog';
import { SidebarModule } from 'primeng/sidebar';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { CookieService } from 'ngx-cookie-service';

// app
import { AppComponent } from './app.component';
import { APP_COMPONENTS, COMPONENTS_SERVICES } from './components/index';
import { APP_SERVICES } from './services/index';
import { APP_RESOLVES } from './resolves/index';
import { SafeHtmlPipe } from './pipes/safeHtml.pipe';
import { DaysPipe } from './pipes/days.pipe';
import { MoneyPipe } from './pipes/money.pipe';
import { ChatTypePipe } from './pipes/chatType.pipe';
import { BooleanValuePipe } from './pipes/booleanValue.pipe';
import { InfiniteScrollDirective } from './directives/infinite.scroll.directive';
import { ServerValidationPipe } from './pipes/server.side.validation.pipe';
import { routes } from './app.routes';
import { AuthGuard } from './guard/auth.guard';
import { AuthUtil } from './utils/auth.utils';
import { AppVersionComponent } from './components/common/app-version/app-version.component';

let routerModule = RouterModule.forRoot(routes);

@NgModule({
  declarations: [
    InfiniteScrollDirective,
    SafeHtmlPipe,
    DaysPipe,
    MoneyPipe,
    ChatTypePipe,
    ServerValidationPipe,
    BooleanValuePipe,
    AppComponent,
    APP_COMPONENTS,
    AppVersionComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    routerModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    SidebarModule,
    CalendarModule,
    DropdownModule,
  ],
  providers: [
    COMPONENTS_SERVICES,
    APP_SERVICES,
    AuthGuard,
    APP_RESOLVES,
    AuthUtil,
    CookieService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts